"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RemarkDialog',
  data: function data() {
    return {
      dialogVisible: false,
      remarkType: '',
      // reconciliation | finance
      remarkContent: '',
      billInfo: {
        billNo: '',
        merchantName: ''
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.remarkType === 'finance' ? '财务备注' : '对账备注';
    },
    remarkLabel: function remarkLabel() {
      return this.remarkType === 'finance' ? '财务备注' : '对账备注';
    }
  },
  methods: {
    /**
     * @param {Object} row - 当前行数据
     * @param {String} type - 备注类型：reconciliation=对账备注, finance=财务备注
     */
    open: function open(row, type) {
      this.remarkType = type || 'reconciliation';
      if (row) {
        this.billInfo.billNo = row.billNo || '';
        this.billInfo.merchantName = row.merchantName || '';
        this.remarkContent = type === 'finance' ? row.financeRemark || '' : row.reconciliationRemark || '';
      }
      this.dialogVisible = true;
    }
  }
};